import { render } from "./plate-charts.vue?vue&type=template&id=469e134a"
import script from "./plate-charts.vue?vue&type=script&lang=ts"
export * from "./plate-charts.vue?vue&type=script&lang=ts"
script.render = render

export default script